export default __webpack_public_path__ + "static/media/Binger-Comments.76b54495.png";